import apiClient from '../../services/api/apiClient.js';

/**
 * Trae TODAS las filas de un catálogo paginado. El backend topa `limit` en 100
 * (`pagination.plugin.js`), y V1 llenaba sus selects con el catálogo completo
 * (`axios.get(URL_CLIENTES)` sin paginar), así que se pagina hasta agotar.
 */
export async function traerCatalogo(url, params = {}) {
  const todas = [];
  let page = 1;
  let totalPages = 1;
  do {
    const { data } = await apiClient.get(url, { params: { ...params, page, limit: 100 } });
    todas.push(...(data.data || []));
    totalPages = data.meta?.pagination?.totalPages || 1;
    page += 1;
  } while (page <= totalPages && page <= 50);
  return todas;
}

/** Orden alfabético por `campo` (V1: `.sort((a,b) => a.name > b.name ? 1 : -1)`). */
export const ordenarPor = (arr, campo = 'name') =>
  [...arr].sort((a, b) => (String(a[campo] ?? '') > String(b[campo] ?? '') ? 1 : -1));

export const PUERTOS = ['Aeropuero CDMX', 'Laredo', 'Lazaro Cardenas', 'Manzanillo', 'Progreso', 'Tijuana', 'Veracruz'];
export const MODALIDADES = ['Tren', 'Camion'];
export const ASEGURADO_OPCIONES = ['No', 'Si', 'No Aplica'];
